// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { MlAndAiQueries } from '../../../../types/server/modules/mlAndAi/queries';

export type * from '../../../../types/server/modules/mlAndAi/queries';

export const createQueries = ( requests: Requests ): MlAndAiQueries => ({
  AiAssistantConversationsById: ( id, query, headers ) => { 
          return requests.get( `/ai-assistant/conversations/${id}`, query, headers ); 
        },
  AiAssistantConversations: ( params?, headers? ) => {
        return requests.get( `/ai-assistant/conversations/:id?`, params, headers );
      },
  AiAssistantConversationMessages: ( params?, headers? ) => {
        return requests.get( `/ai-assistant/conversation-messages/:conversationId?`, params, headers );
      }
});
